export const WarningIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10 7.5V11.6667" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M10.0008 17.8434H4.95084C2.05917 17.8434 0.850839 15.7767 2.25084 13.2517L4.85084 8.56836L7.30084 4.16836C8.78417 1.49336 11.2175 1.49336 12.7008 4.16836L15.1508 8.57669L17.7508 13.26C19.1508 15.785 17.9342 17.8517 15.0508 17.8517H10.0008V17.8434Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M9.99609 14.166H10.0036" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	)
}
